












































































import Vue from 'vue';
import moment from 'moment';
import { evaultCategoryKey, datePickerFormat } from '@/constants';
import DocumentCard from '@/components/my-documents-components/document-list-components/document-card.component.vue';
import { SelectOption } from '@/@types/member';

interface Data {
  page: number;
  selectedDateRangeFilter: string;
  dateRangeFilterOptions: SelectOption[];
  selectedCategoryFilter: string;
  preparedImages: any[];
}

export default Vue.extend({
  name: 'DocumentList',
  props: {
    title: {
      type: String,
      required: true,
    },
    totalAmount: {
      type: Number,
      default: null,
    },
    documents: {
      type: Array as () => any[],
      required: true,
    },
    displayCount: {
      type: Number,
      default: 4,
    },
  },
  data(): Data {
    return {
      page: 1,
      selectedDateRangeFilter: '',
      dateRangeFilterOptions: [
        {
          text: this.$options.filters.t('documents_label_all-dates'),
          value: '',
        },
        {
          text: this.$options.filters.t('documents_label_last-30-days'),
          value: 30,
        },
        {
          text: this.$options.filters.t('documents_label_last-60-days'),
          value: 60,
        },
        {
          text: this.$options.filters.t('documents_label_last-90-days'),
          value: 90,
        },
      ],
      selectedCategoryFilter: '',
      preparedImages: [],
    };
  },
  computed: {
    paginationLength(): number {
      return Math.ceil(this.filteredDocuments.length / this.displayCount);
    },
    currentDocuments(): number {
      const startIndex = this.displayCount * this.page - this.displayCount;
      return this.filteredDocuments.slice(
        startIndex,
        startIndex + this.displayCount,
      );
    },
    filteredDocuments(): any {
      const filtered = this.documents.filter((document) => {
        return (
          this.documentInDateRangeFilter(
            document,
            this.selectedDateRangeFilter,
          ) &&
          this.documentInCategoryFilter(document, this.selectedCategoryFilter)
        );
      });
      return filtered.sort((a, b) => {
        const aName = a.fileNickname ? a.fileNickname : a.fileName,
          bName = b.fileNickname ? b.fileNickname : b.fileName,
          dateComparison = this.compareDates(a.uploadDate, b.uploadDate);
        if (dateComparison) { return dateComparison; }
        if (aName.toLowerCase() < bName.toLowerCase()) { return -1; }
        if (aName.toLowerCase() > bName.toLowerCase()) { return 1; }
        return 0;
      });
    },
    filteredCategories(): SelectOption[] {
      const categories = [];
      this.documents.forEach((document) => {
        const inCategoryArray = categories.indexOf(document.category) > -1;
        if (!inCategoryArray) {
          categories.push(document.category);
        }
      });
      return categories;
    },
    categoryFilterOptions(): SelectOption[] {
      const options = this.filteredCategories.map((categoryKey) => {
        return {
          // @ts-ignore
          value: parseInt(categoryKey),
          // @ts-ignore
          text: this.$options.filters.t(evaultCategoryKey[categoryKey]),
        };
      });
      options.unshift({
        value: '',
        text: this.$options.filters.t('documents_label_all-categories'),
      });
      return options;
    },
    imageDocuments(): any {
      return this.documents.filter((document) => {
        return document.fileName && !document.fileName.endsWith('.pdf');
      });
    },
  },
  methods: {
    compareDates(dateA, dateB): number {
      const momentA = moment(dateA, datePickerFormat);
      const momentB = moment(dateB, datePickerFormat);
      if (momentA.isValid() && !momentB.isValid()) { return 1; }
      if (!momentA.isValid() && momentB.isValid()) { return -1; }
      if (!momentA.isValid() && !momentB.isValid()) { return 0; }
      if (momentA.isAfter(momentB)) { return -1; }
      if (momentA.isBefore(momentB)) { return 1; }
      if (momentA.isSame(momentB)) { return 0; }
      return null;
    },
    filterChanged(googleAnalyticsEvent, filterOptions, filterSelection) {
      const FILTER_SELECTION_OBJECT = filterOptions.find((option) => {
        return option.value === filterSelection;
      });

      if (FILTER_SELECTION_OBJECT) {
        // Trigger Analytics
        window.dataLayer.push({
          event: googleAnalyticsEvent,
          filterSelection: FILTER_SELECTION_OBJECT.text,
        });
      }

      this.page = 1;
    },
    documentInDateRangeFilter(document, dateRangeFilter): boolean {
      const endDate = moment(),
        startDate = moment().subtract(dateRangeFilter, 'days');
      return !dateRangeFilter
        ? true
        : moment(document.uploadDate, datePickerFormat).isSameOrAfter(startDate) &&
            moment(document.uploadDate, datePickerFormat).isSameOrBefore(endDate);
    },
    documentInCategoryFilter(document, categoryFilter): boolean {
      if (!categoryFilter) {
        return true;
      } else {
        if (
          document.category !== null &&
          typeof document.category !== 'undefined'
        ) {
          return document.category.toString() === categoryFilter.toString();
        } else {
          return false;
        }
      }
    },
  },
  components: {
    DocumentCard,
  },
});
